import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";

export default function PortfolioSummaryCards({ summary }) {
  const totalValue = summary.total_value || 0;
  const totalInvested = summary.total_invested || 0;
  const pnl = summary.total_profit_loss || 0;
  const pnlPct = summary.total_profit_loss_percent || 0;

  const cards = [
    { label: "Total Value", value: `$${totalValue.toLocaleString()}`, color: "text-white", testid: "summary-total-value" },
    { label: "Total Invested", value: `$${totalInvested.toLocaleString()}`, color: "text-white", testid: "summary-total-invested" },
    { label: "Profit/Loss", value: `${pnl >= 0 ? "+" : ""}$${pnl.toLocaleString()}`, color: pnl >= 0 ? "text-[#00FFA3]" : "text-[#FF3B30]", testid: "summary-pnl" },
    { label: "Return %", value: `${pnlPct >= 0 ? "+" : ""}${pnlPct.toFixed(2)}%`, color: pnlPct >= 0 ? "text-[#00FFA3]" : "text-[#FF3B30]", testid: "summary-return-pct" },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
      className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8"
    >
      {cards.map((c) => (
        <Card key={c.label} className="glass-effect">
          <CardContent className="p-6">
            <div className="text-sm text-gray-400 mb-2 uppercase tracking-wider">{c.label}</div>
            <div className={`text-3xl font-bold mono ${c.color}`} data-testid={c.testid}>
              {c.value}
            </div>
          </CardContent>
        </Card>
      ))}
    </motion.div>
  );
}
